module.exports = __webpack_public_path__ + "e2b6a2e2c888be0e5d9452a9f4b0fcbf.svg";